import ENV_VARS from '@/config'
import { get, post, put, del } from '@/ports/api'
const { BACKEND_SERVER } = ENV_VARS

// CONTRACT
export const sendSignature = post(`${BACKEND_SERVER}/contracts/%contractId%/sign`)
export const exportContract = get(`${BACKEND_SERVER}/contracts/%contractId%/pdfData`)
export const createContract = post(`${BACKEND_SERVER}/contracts/listings/%listingId%`)
export const cancelContract = del(`${BACKEND_SERVER}/contracts/%contractId%`)

export const sendContract = post(`${BACKEND_SERVER}/contracts/%contractId%/send`)
export const getTenants = get(`${BACKEND_SERVER}/contracts`)
export const getGroupedTenants = get(`${BACKEND_SERVER}/contracts/grouped_by_building`)
export const getContracts = get(`${BACKEND_SERVER}/web/contracts`, { noLoading: true })
export const getContract = get(`${BACKEND_SERVER}/web/contracts/%contractId%`)
export const getListingContracts = get(`${BACKEND_SERVER}/web/contracts/listings/%listingId%`)
export const updateContract = put(`${BACKEND_SERVER}/contracts/%contractId%`)
export const renewContract = post(`${BACKEND_SERVER}/contracts/%contractId%/extensions`)

export const createCustomAddendumTemplate = post(
  `${BACKEND_SERVER}/contracts/custom_addendum_template`
)
export const editCustomAddendumTemplate = put(
  `${BACKEND_SERVER}/contracts/custom_addendum_template/%addendumId%`
)
export const deleteCustomAddendumTemplate = del(
  `${BACKEND_SERVER}/contracts/custom_addendum_template/%addendumId%`
)

// Custom Contract
export const uploadCustomContract = post(
  `${BACKEND_SERVER}/contracts/upload/%contractId%/tenancy_agreement`
)

export const deleteTenancyAgreement = del(
  `${BACKEND_SERVER}/contracts/%contractId%/package/%packageFileId%/tenancy_agreement`
)

export const uploadSupportingDocument = post(
  `${BACKEND_SERVER}/contracts/upload/%contractId%/supporting_document`
)

export const editContractName = post(
  `${BACKEND_SERVER}/contracts/%contractId%/package/%packageFileId%/change_file_name`
)

export const customContractLeaseTerms = put(`${BACKEND_SERVER}/contracts/%contractId%/lease_terms`)

export const customContractGetPackage = get(`${BACKEND_SERVER}/contracts/%contractId%/package`)

export const customContractRecipients = get(`${BACKEND_SERVER}/contracts/%contractId%/recipients`)

export const contractApplicants = get(`${BACKEND_SERVER}/contracts/%contractId%/applicants`)

export const deleteCustomContractPackageFile = del(
  `${BACKEND_SERVER}/contracts/%contractId%/package/%fileId%/supporting_document`
)
export const cancelCustomContract = del(`${BACKEND_SERVER}/contracts/%contractId%/custom`)

export const customContractFieldsMetadata = put(
  `${BACKEND_SERVER}/contracts/%contractId%/package/%packageFileId%/fields_metadata`
)
export const customContractDraftFieldsMetadata = put(
  `${BACKEND_SERVER}/contracts/%contractId%/package/%packageFileId%/fields_metadata/draft`
)

export const customContractAddRecipient = post(
  `${BACKEND_SERVER}/contracts/%contractId%/recipients`
)

export const customContractUpdateSigner = put(
  `${BACKEND_SERVER}/contracts/%contractId%/recipients/%signerId%`
)

export const customContractDeleteSigner = del(
  `${BACKEND_SERVER}/contracts/%contractId%/recipients/%signerId%`
)

export const customContractDeleteSignerWithDocuments = del(
  `${BACKEND_SERVER}/contracts/%contractId%/recipients/%signerId%/documents/all`
)

export const customContractSendSignature = post(
  `${BACKEND_SERVER}/contracts/package/%packageFileId%/sign/%packageSignerId%`
)

export const customContractSend = post(
  `${BACKEND_SERVER}/contracts/%contractId%/send/%packageFileId%`
)
export const stopPadPayments = put(`${BACKEND_SERVER}/contracts/stop_pad/%contractId%`)

export const createCustomContract = post(`${BACKEND_SERVER}/contracts/listings/%listingId%/custom`)

export const customContractGetSignatures = get(
  `${BACKEND_SERVER}/contracts/%contractId%/taps/%tapId%`
)

export const contractChangeStructure = put(`${BACKEND_SERVER}/contracts/%contractId%/structure`)

export const contractStatementOfResponsibility = post(
  `${BACKEND_SERVER}/contracts/%contractId%/package/%packageFileId%/statement_of_responsibility`
)
